import { useScopeParams } from "@/hooks/useScopeParams";
import { MetadataDashboardTemplate } from "@/components/Templates/MetadataDashboardTemplate";

type Props = { siteId: string };

export default function DiscrepanciesTab({ siteId }: Props) {
  const { scope, id } = useScopeParams();
  return (
    <MetadataDashboardTemplate
      type="issues_management"
      siteId={siteId}
      selectionIdentifierColumn="subject"
      constants={{
        wikiLink: "/wiki/guides/data-discrepancies",
        idLink: (subjectId: string) =>
          `/${scope}/${id}/subjects/overview/${subjectId}/overview`,
      }}
    />
  );
}
